import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Table,
  Form,
  Spinner,
  Button,
} from "react-bootstrap";
import {
  resetPagination,
  MAX_ITEMS_IN_PAGE,
  togglePrompt,
} from "../../../store/actions/commonActions";
import {
  fetchUsers,
  filterUsers,
  toggleUser,
  clearUsers,
  searchUsers,
  ENABLE_USER_ACTION,
  DISABLE_USER_ACTION,
  ACTIVE_USER,
  DISABLED_USER,
  RESET_USERS_PAGINATION,
  SET_USERS_PAGINATION,
} from "../../../store/actions/users/usersActions";
import { capitalize, ConfirmDialog } from "../../../common/Utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faTimes,
  faCheckSquare,
} from "@fortawesome/free-solid-svg-icons";

import PageTitle from "../../../common/PageTitle";
import ListPagination from "../../../common/ListPagination";
import Tabs from "../../../common/Tabs";

class Admins extends Component {
  constructor(props) {
    super(props);
    this.action = "";
    this.user = {};
    this.delay = null;
  }

  componentDidMount() {
    this.props.resetPagination(RESET_USERS_PAGINATION);
    this.fetchUsers();
  }

  fetchUsers = (filters = null) => {
    this.props.clearUsers();

    let filterStatus = ACTIVE_USER;

    if (this.pathname === "/settings/admins/disabled") {
      filterStatus = DISABLED_USER;
    }

    if (filters) {
      Object.assign(filters, { is_disabled: filterStatus });
    } else {
      filters = { is_disabled: filterStatus };
    }

    this.props.fetchUsers(filters);
  };

  promptModal = () => {
    let modalTitle = "";
    let modalBody = "";

    if (this.action === ENABLE_USER_ACTION) {
      modalTitle = "Enable User";
      modalBody = "Are you sure you want to enable this user?";
    } else {
      modalTitle = "Disable User";
      modalBody = "Are you sure you want to disable this user?";
    }

    const onHideFunction = () => {
      this.props.togglePrompt(false);
    };

    const onClickCancel = () => {
      this.props.togglePrompt(false);
    };

    const onClickConfirm = () => {
      this.props.toggleUser(this.action, this.user, () => {
        let filterStatus =
          this.pathname === "/settings/admins/disabled"
            ? DISABLED_USER
            : ACTIVE_USER;
        this.props.fetchUsers({ is_disabled: filterStatus });
        this.props.togglePrompt(false);
      });
    };

    return (
      <ConfirmDialog
        show={this.props.common.togglePrompt}
        modalTitle={modalTitle}
        modalBody={modalBody}
        onHideFunction={onHideFunction}
        onClickCancel={onClickCancel}
        onClickConfirm={onClickConfirm}
      />
    );
  };

  filterUsers = () => {
    return (
      <Form.Control
        size="xl"
        type="search"
        placeholder="Search Users"
        onChange={(e) => {
          const filter = e.target.value;

          if (this.delay) {
            clearTimeout(this.delay);
          }

          this.delay = setTimeout(() => {
            this.props.searchUsers(filter, (searchKeyword) => {
              this.fetchUsers(searchKeyword);
            });
          }, 500);
        }}
      />
    );
  };

  renderUsers = () => {
    let userList = [];
    let users = this.props.users.users;
    if (users) {
      userList = users.length ? (
        users.map((user, key) => {
          return (
            <tr key={key}>
              <td className="align-center">
                {capitalize(`${user.last_name}, ${user.first_name}`)}
              </td>
              <td className="align-center">{user.email}</td>
              <td className="align-center">{user.updated_at}</td>
              <td className="align-center">
                <div className="action-btns">
                  <Button
                    size="sm"
                    className="btn-icon ml-3"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.history.push(
                        "/settings/admins/edit?id=" + user.id
                      );
                    }}
                  >
                    <FontAwesomeIcon icon={faPen} /> Edit Info
                  </Button>
                  &nbsp;
                  {user.is_disabled ? (
                    <Button
                      size="sm"
                      className="btn-icon ml-3 "
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.action = ENABLE_USER_ACTION;
                        this.user = user;
                        this.props.togglePrompt(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faCheckSquare} /> Enable
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      className="btn-icon ml-3"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.action = DISABLE_USER_ACTION;
                        this.user = user;
                        this.props.togglePrompt(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faTimes} /> Disable
                    </Button>
                  )}
                </div>
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={6}>
            <Spinner animation="border" size="sm" />
          </td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td colSpan={6}>
            <p className="text-danger">No users found.</p>
          </td>
        </tr>
      );
    }

    return userList;
  };

  render() {
    let listPagination = "";

    this.pathname = this.props.location.pathname;
    const users = this?.props?.users;

    const upsertAdminUser = (
      <Button
        id="add-client"
        size="md"
        onClick={() => {
          this.props.history.push("/settings/admins/new");
        }}
      >
        Create Admin User
      </Button>
    );

    if (!users.userFilter) {
      listPagination = (
        <div className="float-right mt-3">
          <ListPagination
            dispatchType={SET_USERS_PAGINATION}
            data={users.clients}
            min={users.min}
            max={users.max}
            currentPage={users.currentPage}
            totalPages={users.totalPages}
            numItems={users.totalItems}
            fetchCallback={() => {
              this.fetchUsers();
            }}
          />
        </div>
      );
    }

    return (
      <Container className="waa-container container">
        {this.promptModal()}
        <PageTitle pageName="Admin Users" actionButton={upsertAdminUser} />
        <Row className="mb-3">
          <Col>
            <Tabs
              pages={[
                {
                  title: "Active Admins",
                  active: this.pathname === "/settings/admins" ? true : false,
                  onClick: () => {
                    this.props.clearUsers();
                    this.props.fetchUsers({ is_disabled: ACTIVE_USER });
                    this.props.resetPagination(RESET_USERS_PAGINATION);
                    this.props.history.push("/settings/admins");
                  },
                },
                {
                  title: "Disabled Admins",
                  active:
                    this.pathname === "/settings/admins/disabled"
                      ? true
                      : false,
                  onClick: () => {
                    this.props.clearUsers();
                    this.props.fetchUsers({ is_disabled: DISABLED_USER });
                    this.props.resetPagination(RESET_USERS_PAGINATION);
                    this.props.history.push("/settings/admins/disabled");
                  },
                },
              ]}
            />
          </Col>
          <Col>
            <div className="float-right">{listPagination}</div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Table className="waa-table table">
              <thead>
                <tr>
                  <th className="align-center">NAME</th>
                  <th className="align-center">EMAIL</th>
                  <th className="align-center">LAST UPDATE</th>
                  <th className="align-center">ACTION</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4}>{this.filterUsers()}</td>
                </tr>
                {this.renderUsers()}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col>{listPagination}</Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToDispatch = (state) => ({
  users: state.users,
  common: state.common,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUsers: (...args) => dispatch(fetchUsers(...args)),
  resetPagination: (...args) => dispatch(resetPagination(...args)),
  filterUsers: (...args) => dispatch(filterUsers(...args)),
  togglePrompt: (...args) => dispatch(togglePrompt(...args)),
  toggleUser: (...args) => dispatch(toggleUser(...args)),
  clearUsers: () => dispatch(clearUsers()),
  searchUsers: (...args) => dispatch(searchUsers(...args)),
});

export default withRouter(
  connect(mapStateToDispatch, mapDispatchToProps)(Admins)
);
